document.addEventListener("DOMContentLoaded", () => {
  // footer accordion

  const footerMobileAccordion = () => {
    const parents = document.querySelectorAll(".footer__menus .widget");
    parents.forEach((parent) => {
      const title = parent.querySelector(".widget-title");
      const content = parent.querySelector("div");
      if (content) {
        const icon = `
        <svg class="footer-accordion-icon" viewBox="0 0 20 20" width="20" height="20" fill="none">
            <path fill="#0B0B0B" d="M0 9h20v2H0V9Z"/>
            <path fill="#0B0B0B" d="M9 20V0h2v20H9Z"/>
        </svg>
			`;
        title.insertAdjacentHTML("beforeend", icon);

        title.addEventListener("click", (e) => {
          title.classList.toggle("open");
          content.classList.toggle("open");
        });
      }
    });
  };

  const initFooterAccordion = () => {
    // Надо ли инициировать функцию
    let shouldInitAccordion = true;

    // Вызываю функцию, если шиирина экрана меньше 576px
    if (window.innerWidth < 576) {
      footerMobileAccordion();
      shouldInitAccordion = false;
    }

    // Вызываю функцию, при ресайзе окна и если шиирина экрана меньше 576px
    window.addEventListener("resize", () => {
      if (shouldInitAccordion && window.innerWidth < 576) {
        footerMobileAccordion();
        shouldInitAccordion = false;
      }
    });
  };

  initFooterAccordion();

  // end footer accordion
});
